import React, { useState, useEffect, useContext } from "react";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../../ui-styles/list/AttachmentList.css";
import "../../../ui-styles/sliders/RightFullSlider.css";
import "../../../ui-styles/list/profileVertical.css";
import { LangCtx } from "../../../lib/context";
import { dateFormat, getAge, timeFormat } from "../../../lib/functions";
import { getPatientDrugAllegiesById, getPatientMedicalFilesById } from "../../../actions/appointment";
import { getRecordingsById } from "../../../actions/schedule";
// import { getUserDetails } from "../../../actions/users";
import UploadFilesListItem from "../../common/fileUploads/components/slidelistItem";
import Loader from "../../../lib/ui/loader/Loader";
import NoData from "../../../lib/ui/nodata/NoData";
import MedicalHistory from "./medicalHistory";
import PatientHistoryDetails from "../../conference/components/patientHistoryDetails";
import RecordingsList from "../Video";
import {API} from 'aws-amplify';
import NewPrescription from "../../conference/components/newPrescription";
import PrescriptionSlide from "../../conference/components/PrescriptionSlide";

const VisitDetailsSlide = (props) => {
    const { l } = useContext(LangCtx);
    const { data } = props;
    const [drugs, setDrugs] = useState([]);
    const { patientData } = data;
    const [uploadData, setUploadData] = useState(data?.uploads && data.uploads.length > 0 ? data.uploads : []);
    const [loading, setLoading] = useState(false);
    const [current, setTab] = useState("PEA");
    const [recordingData,setRecordingData]=useState([]);
    
    useEffect(() => {
        if (props.data && props.data.patientId) {
            setLoading(true);
            patientDrugAllegies();
            patientUploadData();
            appointmentRecordingData();
        }
    }, [props.data.patientId]);

    const patientUploadData = () => {
        getPatientMedicalFilesById(props.data.patientId)
            .then((res) => {
                setLoading(false);
                if (res.data && res.status) {
                    setUploadData([...uploadData, ...res.data]);
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err in loading doctors files ==== ", err);
            });
    };
    const appointmentRecordingData = () => {
        getRecordingsById(props.data.appointmentId)
        // getRecordingsById(props.data.clinicId)
            .then((res) => {
                // setLoading(false);
                console.log("res...........",res);
                if (res.data && res.status) {
                    setRecordingData([...recordingData, ...res.data]);
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err in loading recordingData files ==== ", err);
            });
    };

    const patientDrugAllegies = () => {
        setLoading(true);
        getPatientDrugAllegiesById(props.data.patientId)
            .then((res) => {
                if (res.status && res.data) {
                    setDrugs(res.data);
                } else {
                    setDrugs([]);
                }
            })
            .catch((err) => {
                console.log("err ==== ", err);
                setDrugs([]);
            });
    };

    return (
        <div className={props.visitDetails ? "visitInfoSlider visitInfoSliderIn" : "visitInfoSlider"}>
            {loading && <Loader />}
            {!loading && (
                <div className="rightSliderHdr">
                    <div className="hdrRowBlock">
                        <div className="flexMinWidthRow">
                            <div className="tabCol">
                                <div className="row hndlpdn08 hideScrollX">
                                    <div
                                        className={current === "PEA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                                        onClick={(e) => setTab("PEA")}
                                    >
                                        <span>{l.visit_info}</span>
                                    </div>
                                    <div
                                        className={current === "PRC" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                                        onClick={() => setTab("PRC")}
                                    >
                                        <span>{l.presc}</span>
                                    </div>
                                    <div
                                        className={current === "MH" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                                        onClick={() => setTab("MH")}
                                    >
                                        <span>Internal Notes</span>
                                    </div>
                                    <div
                                        className={current === "PH" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                                        onClick={() => setTab("PH")}
                                    >
                                        <span>Medical History</span>
                                    </div>
                                   {data.clinicData.cloudRecordings && <div
                                        className={current === "REC" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                                        onClick={() => setTab("REC")}
                                    >
                                        <span>Recordings</span>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="flexAutoRow">
                            <div className="hdrActionGroup" onClick={props.handleClose}>
                                <div className="hdrActItem close"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!loading && current === "PEA" && (
                <div className="rightSliderBdy">
                    <div className="profleAvtrRow">
                        <div className="profleAvtrCircle">
                            <img
                                src={
                                    patientData && patientData.profileImage && patientData.profileImage.url
                                        ? patientData.profileImage.url
                                        : "/images/icons/patient-default.png"
                                }
                                alt="avatarimg"
                            />
                        </div>
                        <div className="profileMinDtls">
                            <span className="profileLtxt">{patientData.name ? `${patientData.name}` : "-"}</span>
                            <span className="profileStxt capitalizeTxt">
                                {patientData.gender} {patientData.dob ? `- ${getAge(new Date(patientData.dob))}` : "-"}
                            </span>
                        </div>
                    </div>
                    <div className="inColBlock">
                        <span className="subHdngSm">{l.appt_details}:</span>
                        <ul className="colListGroup">
                            {data?.updatedAt && (
                                <li className="colListItem">
                                    <span className="subHdngSm">{l.upload_date}</span>
                                    <span className="itemTxt">{data?.updatedAt && dateFormat(data.updatedAt)}</span>
                                </li>
                            )}
                            <li className="colListItem">
                                <span className="subHdngSm">{l.time}</span>
                                <span className="itemTxt">
                                    {timeFormat(data.startTime)} - {timeFormat(data.endTime)}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div className="inColBlock">
                        <span className="subHdngSm">{l.reas_for_call}</span>
                        <p className="summaryTxt">{data.reason ? l[data.reason] : "-"}</p>
                        <span className="subHdngSm">{l.pat_visit_summary}</span>
                        <p className="summaryTxt">{data.description ? decodeURIComponent(data.description) : "-"}</p>
                    </div>

                    <div className="inColBlock">
                        <span className="subHdngSm">{l.attachments}:</span>
                        <ul className="colListGroup">
                            {uploadData.length > 0 ? (
                                uploadData.map((item, i) => <UploadFilesListItem file={item} key={`${item.key}_${i}`} access={true} />)
                            ) : (
                                <NoData Heading={l.no_files} src="/images/file-icons/blank-file.png" label="" />
                            )}
                        </ul>
                    </div>

                    <div className="inColBlock">
                        <span className="subHdngSm">{l.drug_All}</span>
                        <ul className="colListGroup">
                            {drugs && drugs.length > 0 ? (
                                drugs.map((drugItem, index) => (
                                    <li className="colListItem" key={`${drugItem.name}_${index}`}>
                                        <span className="subHdngSm">
                                            {l.drug_name}: {decodeURIComponent(drugItem.name)}
                                        </span>
                                        <span className="itemTxt">{decodeURIComponent(drugItem.description)}</span>
                                    </li>
                                ))
                            ) : (
                                <NoData Heading={l.no_drug_allergy} src="/images/icons/tablets-new.png" label="" />
                            )}
                        </ul>
                    </div>
                    <div className="inColBlock">
                        <span className="subHdngSm">{l.med_det}</span>
                        <ul className="colListGroup">
                            <li className="colListItem">
                                <span className="subHdngSm">{l.pat_id}</span>
                                <span className="itemTxt">{patientData.consultId ? patientData.consultId : "-"}</span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.blood_group}</span>
                                <span className="itemTxt">{patientData.bloodgroup ? decodeURIComponent(patientData.bloodgroup) : "-"}</span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.pat_phone_no}</span>
                                <span className="itemTxt">
                                    {patientData.countryCode ? "+" + patientData.countryCode : ""}{" "}
                                    {patientData.phone ? patientData.phone : "-"}
                                </span>
                            </li>
                            <li className="colListItem">
                                <span className="subHdngSm">{l.pat_email}</span>
                                <span className="itemTxt">{patientData.email ? patientData.email : "-"}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
            {current === "MH" && <MedicalHistory current={current} close={() => setTab("")} data={data} />}
            {current === "PH" && <PatientHistoryDetails current={current} close={() => setTab("")} data={data} />}
            {current === "REC" && <RecordingsList current={current} close={() => setTab("")} recordingData={recordingData} />}
            {current === "PRC" && <PrescriptionSlide current={current} close={() => setTab("")} data={data} />}
        </div>
    );
};

export default VisitDetailsSlide;
